import React from 'react';
import { FINISH_STEP, GO_BACK_TO_STEP, } from '../../storage/TutorialReducer';
import { withRouter } from 'react-router-dom';

class TutorialStep7 extends React.Component {
  componentDidMount () {
    if (this.props.location.pathname !== '/settings') {
      this.props.history.push('/settings');
    }
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 7});
  }

  goBack () {
    Storage.dispatch({type: GO_BACK_TO_STEP, payload: 6});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2 className="c-tutorial-element__subtitle">
          Settings page
        </h2>
        <p>
          Here you can set your name that everybody that uses ASC sees.
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goBack}>Back</button>
          <button onClick={this.goNext}>Next</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TutorialStep7);



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep7.js